<template>
    <section>
        <div class="row">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0 active" aria-current="page">
                            Dashboard
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row mb-2 align-items-end">
            <div class="col">
                <h3>
                    Welcome to BTA Group Management System<br />
                    <small>Please navigate from navigation Menu</small>
                </h3>
            </div>
            <div class="col-12 col-sm-auto text-right" v-if="roleElligiblePrimary() || roleElligibleSecondary()">
                <button type="button" class="btn btn-sm btn-danger mr-2" v-on:click="modal.score = true">
                    Download Laporan Nilai
                </button>
                <button type="button" class="btn btn-sm btn-danger mr-2" v-on:click="modal.upload = true">
                    Upload Rekap Kehadiran Siswa
                </button>
                <button type="button" class="btn btn-sm btn-outline-danger px-3 mr-2" v-on:click="modal.utbk = true">
                    Download Nilai UTBK
                </button>
                <button type="button" class="btn btn-sm btn-danger px-3" v-on:click="modal.student = true">
                    Download Data Siswa
                </button>
            </div>
        </div>
        <template v-if="roleElligiblePrimary() || roleElligibleSecondary()">
            <div class="row mb-4">
                <div class="col-12">
                    <div class="card shadow-sm mb-4 border-0">
                        <template v-if="roleElligiblePrimary()">
                            <div class="card-header background-primary">
                                <div class="row justify-content-end">
                                    <div class="col">
                                        <span class="h4 font-weight-medium text-white mb-0">
                                            Jumlah Siswa BTA Per-Cabang
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body px-5">
                                <div class="position-relative graph-wrapper">
                                    <div class="w-100 donut-chart">
                                        <IEcharts v-bind:option="graphData.donuts[0]" resizable />
                                    </div>
                                    <div class="position-absolute text-center title">
                                        <h1 class="mb-0 font-weight-bold">{{ graphData.donuts[0].title.text }}</h1>
                                        <p class="mb-0 text-muted mx-auto" style="max-width: 150px;">
                                            {{ graphData.donuts[0].title.subtext }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="roleElligibleSecondary()">
                            <div class="card-header background-primary">
                                <div class="row justify-content-end">
                                    <div class="col">
                                        <span class="h4 font-weight-medium text-white mb-0">
                                            Jumlah Siswa Per-Kelas
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body px-5">
                                <div class="position-relative graph-wrapper">
                                    <div class="w-100 donut-chart">
                                        <IEcharts v-bind:option="graphData.donuts[1]" resizable />
                                    </div>
                                    <div class="position-absolute text-center title">
                                        <h1 class="mb-0 font-weight-bold">{{ graphData.donuts[1].title.text }}</h1>
                                        <p class="mb-0 text-muted mx-auto" style="max-width: 150px;">
                                            {{ graphData.donuts[1].title.subtext }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="col-12">
                    <div class="card shadow-sm mb-4 border-0">
                        <div class="card-header background-primary">
                            <div class="row justify-content-end">
                                <div class="col">
                                    <span class="h4 font-weight-medium text-white mb-0">
                                        Jumlah Sekolah Asal Peserta BTA Per-Cabang
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="card-body px-5">
                            <div class="row" v-if="roleElligiblePrimary()">
                                <div class="col form-inline mb-3">
                                    <!-- Filter Cabang -->
                                    <div class="form-group mr-4">
                                        <label class="font-weight-medium text-muted mb-0 h4 form-divider mx-3">Cabang</label>
                                        <select v-model="form.graph.donut.branchID" class="form-control form-control-sm" v-on:change="fetchSchoolGraph()" required>
                                            <option value="">Seluruh Cabang...</option>
                                            <option v-for="branch in branches" v-bind:value="branch.id" v-bind:key="branch.id">{{ branch.name }}</option>
                                        </select>
                                    </div>

                                    <!-- Filter Program Studi / BTA Grade -->
                                    <div class="form-group">
                                        <label class="font-weight-medium text-muted mb-0 h4 form-divider mr-3">Program Studi</label>
                                        <select v-model="form.graph.donut.gradeID" class="form-control form-control-sm" v-on:change="fetchSchoolGraph()">
                                            <option value="">Seluruh Program Studi...</option>
                                            <option v-for="grade in grades" v-bind:value="grade.id" v-bind:key="grade.id">{{ grade.name }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="position-relative graph-wrapper">
                                <div class="w-100 donut-chart">
                                    <IEcharts v-bind:option="graphData.donuts[2]" resizable />
                                </div>
                                <div class="position-absolute text-center title">
                                    <h1 class="mb-0 font-weight-bold">{{ graphData.donuts[2].title.text }}</h1>
                                    <p class="mb-0 text-muted mx-auto" style="max-width: 150px;">
                                        <template v-if="!Object.keys(guessBranch).length">
                                            {{ graphData.donuts[2].title.subtext }}
                                        </template>
                                        <template v-else>
                                            Jumlah Siswa {{ guessBranch.name }}
                                        </template>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="roleElligiblePrimary()">
                <div class="row">
                    <div class="col">
                        <div class="slim-scroll scroll-x" v-dragscroll>
                            <div class="card shadow-sm mb-4 border-0" style="min-width: 100%;" v-bind:style="{width: (150 * graphData.bar.xAxis[0].data.length) + 'px'}">
                                <div class="card-header background-primary">
                                    <div class="row justify-content-end">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Jumlah Siswa BTA Per-Prodi
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="w-100" style="height: 600px;">
                                        <IEcharts v-bind:option="graphData.bar" resizable />
                                    </div>
                                    <div class="row justify-content-center">
                                        <div class="col-8 text-center">
                                            <div class="form-check form-check-inline mb-2 mr-4" v-for="grade in grades" v-bind:key="grade.id">
                                                <div class="custom-control custom-checkbox">
                                                    <input v-model="form.graph.bar.gradeIDs" type="checkbox" v-bind:value="grade.id" class="custom-control-input" v-bind:id="'input-grade-' + grade.id" />
                                                    <label class="custom-control-label" v-bind:for="'input-grade-' + grade.id">{{ grade.name }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </template>

       
        <!-- ===============================================-->
        <!-- Popup Pengumuman BTA GROUP -->
        <!-- Update: 19 Oktober 2026 -->
        <!-- ===============================================-->

        <b-modal
            v-model="popup"
            size="lg"
            modal-class="border-0"
            header-class="background-primary"
            footer-class="justify-content-center"
            centered
            hide-footer
        >
            <template slot="modal-header">
                <h4
                    class="container text-uppercase text-white font-weight-bold text-center mb-0"
                >
                    📢 PENGUMUMAN
                </h4>
            </template>

            <div class="container announcement-body">

                <!-- ================= JUDUL ================= -->

                <h3
                    class="announcement-title text-center font-weight-bold mb-2"
                    style="color:#1565c0;"
                >
                    JADWAL TRY OUT<br class="d-sm-none">
                    SEMESTER 1
                </h3>

                <p class="announcement-subtitle text-center text-muted mb-3">
                    BTA GROUP Tahun Ajaran 2026–2027
                </p>

                <hr>

                <p>
                    Kepada seluruh <strong>Tim BTA GROUP</strong>,
                </p>

                <p>
                    Berikut kami informasikan jadwal pelaksanaan
                    <strong>Try Out Semester 1 BTA GROUP Tahun Ajaran 2026–2027</strong>.
                    Mohon seluruh tim terkait dapat mempersiapkan kebutuhan sesuai
                    jadwal yang telah ditentukan.
                </p>


                <!-- ================= KELAS XII ================= -->

                <div class="to-section">

                    <div
                        class="to-section-header"
                        style="background:#e3f2fd;"
                    >
                        <strong style="color:#1565c0;">
                            🎓 Kelas XII
                        </strong>
                    </div>

                    <div class="to-section-body">

                        <!-- TKA 1 / SELESAI -->

                        <div class="to-row">
                            <div class="to-name">
                                <strong style="color:#757575;">
                                    TKA 1
                                </strong>

                                <span
                                    style="
                                        background:#f5f5f5;
                                        color:#757575;
                                        font-size:9px;
                                        font-weight:bold;
                                        margin-left:5px;
                                        padding:3px 7px;
                                        border-radius:4px;
                                        white-space:nowrap;
                                    "
                                >
                                    SELESAI
                                </span>
                            </div>

                            <div class="to-date" style="color:#9e9e9e;">
                                17–23 Agu 2026
                            </div>
                        </div>


                        <!-- TKA 2 + UTBK 1 / SELESAI -->

                        <div class="to-row">
                            <div class="to-name">
                                <strong style="color:#757575;">
                                    TKA 2 + UTBK 1
                                </strong>

                                <span
                                    style="
                                        background:#f5f5f5;
                                        color:#757575;
                                        font-size:9px;
                                        font-weight:bold;
                                        margin-left:5px;
                                        padding:3px 7px;
                                        border-radius:4px;
                                        white-space:nowrap;
                                    "
                                >
                                    SELESAI
                                </span>
                            </div>

                            <div class="to-date" style="color:#9e9e9e;">
                                21–27 Sep 2026
                            </div>
                        </div>


                        <!-- TKA 3 / SELESAI -->

                        <div class="to-row">
                            <div class="to-name">
                                <strong style="color:#757575;">
                                    TKA 3
                                </strong>

                                <span
                                    style="
                                        background:#f5f5f5;
                                        color:#757575;
                                        font-size:9px;
                                        font-weight:bold;
                                        margin-left:5px;
                                        padding:3px 7px;
                                        border-radius:4px;
                                        white-space:nowrap;
                                    "
                                >
                                    SELESAI
                                </span>
                            </div>

                            <div class="to-date" style="color:#9e9e9e;">
                                12–18 Okt 2026
                            </div>
                        </div>


                        <!-- UTBK 2 -->

                        <div class="to-row">
                            <div class="to-name">
                                UTBK 2
                            </div>

                            <div class="to-date">
                                9–15 Nov 2026
                            </div>
                        </div>


                        <!-- UTBK 3 -->

                        <div class="to-row">
                            <div class="to-name">
                                UTBK 3
                            </div>

                            <div class="to-date">
                                14–20 Des 2026
                            </div>
                        </div>

                    </div>
                </div>


                <!-- ================= KELAS X & XI ================= -->

                <div class="to-section">

                    <div
                        class="to-section-header"
                        style="background:#f3e5f5;"
                    >
                        <strong style="color:#7b1fa2;">
                            📚 Kelas X & XI
                        </strong>
                    </div>

                    <div class="to-section-body">

                        <!-- ASSESSMENT 1 / SELESAI -->

                        <div class="to-row">
                            <div class="to-name">
                                <strong style="color:#757575;">
                                    Assessment 1
                                </strong>

                                <span
                                    style="
                                        background:#f5f5f5;
                                        color:#757575;
                                        font-size:9px;
                                        font-weight:bold;
                                        margin-left:5px;
                                        padding:3px 7px;
                                        border-radius:4px;
                                        white-space:nowrap;
                                    "
                                >
                                    SELESAI
                                </span>
                            </div>

                            <div class="to-date" style="color:#9e9e9e;">
                                24–30 Agu 2026
                            </div>
                        </div>


                        <!-- ASSESSMENT 2 / SELESAI -->

                        <div class="to-row">
                            <div class="to-name">
                                <strong style="color:#757575;">
                                    Assessment 2
                                </strong>

                                <span
                                    style="
                                        background:#f5f5f5;
                                        color:#757575;
                                        font-size:9px;
                                        font-weight:bold;
                                        margin-left:5px;
                                        padding:3px 7px;
                                        border-radius:4px;
                                        white-space:nowrap;
                                    "
                                >
                                    SELESAI
                                </span>
                            </div>

                            <div class="to-date" style="color:#9e9e9e;">
                                21–27 Sep 2026
                            </div>
                        </div>


                        <!-- ASSESSMENT 3 / SEDANG BERLANGSUNG -->

                        <div class="to-row to-row-active">
                            <div class="to-name" style="color:#2e7d32;">
                                Assessment 3

                                <span
                                    class="blink-active"
                                    style="
                                        display:inline-block;
                                        background:#2e7d32;
                                        color:#fff;
                                        font-size:9px;
                                        font-weight:bold;
                                        margin-left:5px;
                                        padding:3px 7px;
                                        border-radius:4px;
                                        white-space:nowrap;
                                    "
                                >
                                    SEDANG BERLANGSUNG
                                </span>
                            </div>

                            <div
                                class="to-date font-weight-bold"
                                style="color:#2e7d32;"
                            >
                                19–31 Okt 2026
                            </div>
                        </div>


                        <!-- TO PAS -->

                        <div class="to-row">
                            <div class="to-name">
                                TO PAS
                            </div>

                            <div class="to-date">
                                9–15 Nov 2026
                            </div>
                        </div>

                    </div>
                </div>


                <!-- ================= SMP ================= -->

                <div class="to-section">

                    <div
                        class="to-section-header"
                        style="background:#e8f5e9;"
                    >
                        <strong style="color:#2e7d32;">
                            📗 SMP
                        </strong>
                    </div>

                    <div class="to-section-body">

                        <!-- EVALUASI 1 / SELESAI -->

                        <div class="to-row">
                            <div class="to-name">
                                <strong style="color:#757575;">
                                    Evaluasi 1
                                </strong>

                                <span
                                    style="
                                        background:#f5f5f5;
                                        color:#757575;
                                        font-size:9px;
                                        font-weight:bold;
                                        margin-left:5px;
                                        padding:3px 7px;
                                        border-radius:4px;
                                        white-space:nowrap;
                                    "
                                >
                                    SELESAI
                                </span>
                            </div>

                            <div class="to-date" style="color:#9e9e9e;">
                                24–30 Agu 2026
                            </div>
                        </div>


                        <!-- EVALUASI 2 / SELESAI -->

                        <div class="to-row">
                            <div class="to-name">
                                <strong style="color:#757575;">
                                    Evaluasi 2
                                </strong>

                                <span
                                    style="
                                        background:#f5f5f5;
                                        color:#757575;
                                        font-size:9px;
                                        font-weight:bold;
                                        margin-left:5px;
                                        padding:3px 7px;
                                        border-radius:4px;
                                        white-space:nowrap;
                                    "
                                >
                                    SELESAI
                                </span>
                            </div>

                            <div class="to-date" style="color:#9e9e9e;">
                                28 Sep–4 Okt 2026
                            </div>
                        </div>


                        <!-- EVALUASI 3 / COMING NEXT -->

                        <div class="to-row to-row-next">
                            <div class="to-name">
                                Evaluasi 3

                                <span class="to-badge-next">
                                    COMING NEXT
                                </span>
                            </div>

                            <div class="to-date">
                                2–8 Nov 2026
                            </div>
                        </div>


                        <!-- EVALUASI 4 -->

                        <div class="to-row">
                            <div class="to-name">
                                Evaluasi 4
                            </div>

                            <div class="to-date">
                                23–29 Nov 2026
                            </div>
                        </div>

                    </div>
                </div>


                <!-- ================= BATAS BAHAN ================= -->

                <div
                    style="
                        background:#fff8e1;
                        border-left:5px solid #f9a825;
                        padding:15px;
                        border-radius:8px;
                        margin-top:20px;
                        margin-bottom:15px;
                    "
                >
                    <strong>
                        📌 Batas Pengumpulan Bahan TO
                    </strong>

                    <p class="mb-0 mt-2">
                        Seluruh bahan TO wajib diserahkan maksimal
                        <strong>2 minggu sebelum TO dimulai</strong>.<br><br>

                        Satu minggu sebelum pelaksanaan, tim wajib melakukan
                        <strong>pengecekan akhir</strong> terhadap soal dan pembahasan
                        yang telah dimasukkan ke sistem.
                    </p>
                </div>


                <!-- ================= JADWAL PENGAJAR ================= -->

                <div
                    style="
                        background:#f8f9fa;
                        border:1px solid #dee2e6;
                        border-radius:8px;
                        padding:15px;
                    "
                >
                    <strong>
                        🔗 Jadwal Pengajar & Ruang BTA GROUP 2026–2027
                    </strong>

                    <p class="mb-2 mt-2">
                        Jadwal Pengajar & Ruang dapat dilihat melalui:
                    </p>

                    <a
                        href="https://bit.ly/jadwalbta2027"
                        target="_blank"
                        rel="noopener noreferrer"
                        style="font-weight:bold;"
                    >
                        https://bit.ly/jadwalbta2027
                    </a>
                </div>


                <!-- ================= PENUTUP ================= -->

                <p class="text-center text-muted mt-4 mb-4">
                    <em>
                        Mohon seluruh tim terkait memperhatikan jadwal dan batas waktu
                        yang telah ditentukan. Terima kasih atas perhatian dan kerja samanya.
                    </em>
                </p>


                <!-- ================= TOMBOL TUTUP ================= -->

                <button
                    v-on:click="popup = false"
                    class="btn btn-outline-danger px-5 d-block mx-auto"
                >
                    Tutup
                </button>

            </div>
        </b-modal>

        <!-- ===============================================-->
        <!-- Penutup Popup -->
        <!-- ===============================================-->



        <b-modal v-model="modal.student" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true" v-if="roleElligiblePrimary() || roleElligibleSecondary()">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Download Data Siswa
                </h4>
            </template>
            <div class="container">
                <form v-on:submit.prevent="downloadStudent">
                    <div class="row">
                        <div class="col-12 mb-4" v-if="roleElligiblePrimary()">
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Cabang</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <select v-model="form.student.branchID" class="form-control form-control-sm" required>
                                        <option disabled value="" selected>Pilih Cabang...</option>
                                        <option v-for="branch in branches" v-bind:value="branch.id" v-bind:key="branch.id">{{ branch.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center">
                            <button type="submit" class="btn btn-danger btn-sm px-5 mx-2 mb-2">
                                Download
                            </button>
                            <button class="btn btn-outline-danger btn-sm px-5 mx-2 mb-2" type="button" v-on:click="modal.student = false">
                                Batal
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
        <b-modal v-model="modal.utbk" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true" v-if="roleElligiblePrimary() || roleElligibleSecondary()">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Download Data UTBK Siswa
                </h4>
            </template>
            <div class="container">
                <form v-on:submit.prevent="downloadUTBK">
                    <div class="row">
                        <div class="col-12 mb-4" v-if="roleElligiblePrimary()">
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Cabang</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <select v-model="form.utbk.branchID" class="form-control form-control-sm" required>
                                        <option disabled value="" selected>Pilih Cabang...</option>
                                        <option v-for="branch in branches" v-bind:value="branch.id" v-bind:key="branch.id">{{ branch.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center">
                            <button type="submit" class="btn btn-danger btn-sm px-5 mx-2 mb-2">
                                Download
                            </button>
                            <button class="btn btn-outline-danger btn-sm px-5 mx-2 mb-2" type="button" v-on:click="modal.utbk = false">
                                Batal
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
        <b-modal v-model="modal.upload" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Upload Rekap Kehadiran Siswa
                </h4>
            </template>
            <div class="container">
                <form v-on:submit.prevent="upload">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <div class="row align-items-center">
                                <div class="col text-right">
                                    <a v-bind:href="'/static/template/data-sample-attendance-report.csv?timestamp=' + $moment(new Date).format('X')" class="mb-0 small">
                                        Download Template
                                    </a>
                                </div>
                            </div>
                            <div class="row mb-2 align-items-center">
                                <div class="col text-right">
                                    <a v-bind:href="'/static/template/data-sample-additional-attendance.csv?timestamp=' + $moment(new Date).format('X')" class="mb-0 small">
                                        Download Template Tambahan
                                    </a>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Pilih Semester</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <select v-model="form.upload.semester" class="form-control form-control-sm" required>
                                        <option disabled value="" selected>Pilih Semester...</option>
                                        <option v-for="semester in semesters" v-bind:value="semester.id" v-bind:key="semester.id">{{ semester.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider">File</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <input id="file-upload" type="file" class="form-control" v-on:change="fileUpload($event, 'attendance-report')" placeholder="Choose File" accept=".xlsx, .xls, .csv" />
                                    <label for="file-upload" class="form-control form-control-sm text-truncate mb-0">
                                        <button type="button" class="btn btn-danger font-weight-bold">
                                            Choose File
                                        </button>
                                        {{ form.upload['attendance-report'].name }}
                                    </label>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider">File Tambahan</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <input id="file-upload-additional" type="file" class="form-control" v-on:change="fileUpload($event, 'additional-attendance')" placeholder="Choose File" accept=".xlsx, .xls, .csv" />
                                    <label for="file-upload-additional" class="form-control form-control-sm text-truncate mb-0">
                                        <button type="button" class="btn btn-danger font-weight-bold">
                                            Choose File
                                        </button>
                                        {{ form.upload['additional-attendance'].name }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center">
                            <button type="submit" class="btn btn-danger btn-sm px-5 mx-2 mb-2">
                                Submit
                            </button>
                            <button class="btn btn-outline-danger btn-sm px-5 mx-3 mb-2" type="button" v-on:click="modal.upload = false">
                                Batal
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
        <b-modal v-model="modal.score" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Download Laporan Nilai
                </h4>
            </template>
            <div class="container">
                <form v-on:submit.prevent="downloadScore">
                    <div class="row">
                        <div class="col-12">
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Pilih Cabang</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <select v-model="branchID" class="form-control form-control-sm" required>
                                        <option disabled value="" selected>Pilih Cabang...</option>
                                        <option v-for="branch in branches" v-bind:value="branch.id" v-bind:key="branch.id">{{ branch.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-12" v-if="branchID">
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Pilih Program</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <select v-model="branchProgramID" class="form-control form-control-sm" required>
                                        <option disabled value="" selected>Pilih Program...</option>
                                        <option v-for="branchProgram in branchPrograms" v-bind:value="branchProgram.id" v-bind:key="branchProgram.id">{{ branchProgram.grade.name }} - {{ branchProgram.programType.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-12" v-if="branchProgramID">
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Pilih Pola</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <select v-model="patternID" class="form-control form-control-sm" required>
                                        <option disabled value="" selected>Pilih Pola...</option>
                                        <option v-for="pattern in patterns" v-bind:value="pattern.id" v-bind:key="pattern.id">{{ patternLabel(pattern) }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-12" v-if="patternID">
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Pilih Kelas BTA</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <select v-model="form.score.branchClassID" class="form-control form-control-sm" required>
                                        <option disabled value="" selected>Pilih Kelas BTA...</option>
                                        <option v-for="branchClass in branchClasses" v-bind:value="branchClass.id" v-bind:key="branchClass.id">{{ branchClass.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mt-4 text-center">
                            <button type="submit" class="btn btn-danger btn-sm px-5 mx-2 mb-2">
                                Submit
                            </button>
                            <button class="btn btn-outline-danger btn-sm px-5 mx-2 mb-2" type="button" v-on:click="modal.score = false">
                                Batal
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import IEcharts from 'vue-echarts-v3/src/full.js';
    import qs from 'qs';
    import { dragscroll } from 'vue-dragscroll';
    import { semesters } from '@/params.js';

    export default {
        name: "Index",
        directives: {dragscroll},
        components: {
            IEcharts: IEcharts
        },
        computed: mapState([
            'profile',
            'term'
        ]),
        watch: {
            'form.graph.bar.gradeIDs': {
                handler() {
                    if (this.roleElligiblePrimary()) {
                        this.fetchGradeGraph();
                    }
                },
                deep: true
            },
            // WATCHER UNTUK MONITOR PERUBAHAN FILTER PROGRAM STUDI / GRADE
            'form.graph.donut.gradeID'() {
                this.fetchSchoolGraph();
            },
            // WATCHER UNTUK MONITOR PERUBAHAN FILTER CABANG
            'form.graph.donut.branchID'() {
                this.fetchSchoolGraph();
            },
            profile() {
                this.fetchData();
            },
            term() {
                this.fetchData();
            },
            branchID() {
                if (this.branchID) {
                    this.axios.get(process.env.API_URL + '/branch-program', {params: {branchID: this.branchID}}).then(response => {
                        this.branchPrograms = response.data.data;
                    });
                } else {
                    this.branchPrograms = [];
                }
                this.branchProgramID = '';
                this.patternID = '';
                this.form.score.branchClassID = '';
            },
            branchProgramID() {
                if (this.branchProgramID) {
                    this.axios.get(process.env.API_URL + '/pattern', {params: {branchProgramID: this.branchProgramID}}).then(response => {
                        this.patterns = response.data.data;
                    });
                } else {
                    this.patterns = [];
                }
                this.patternID = '';
                this.form.score.branchClassID = '';
            },
            patternID() {
                if (this.patternID) {
                    this.axios.get(process.env.API_URL + '/branch-class', {params: {patternID: this.patternID}}).then(response => {
                        this.branchClasses = response.data.data;
                    });
                } else {
                    this.branchClasses = [];
                }
                this.form.score.branchClassID = '';
            }
        },
        data() {
            let colors = ['#FEC401', '#94C126', '#d31027', '#C114C8', '#88429B', '#1457A6', '#18AB29', '#FE8200', '#38EF7D', '#00ADEF'];
            return {
                form: {
                    graph: {
                        bar: {gradeIDs: []},
                        donut: {
                            branchID: '',
                            gradeID: '' // STATE PILIHAN PROGRAM STUDI
                        }
                    },
                    student: {
                        branchID: ''
                    },
                    utbk: {
                        branchID: ''
                    },
                    upload: {'attendance-report': '', 'additional-attendance': '', semester: ''},
                    score: {branchClassID: ''}
                },
                popup: true,
                modal: {student: false, utbk: false, upload: false, score: false},
                branchID: '',
                branchProgramID: '',
                patternID: '',
                guessBranch: {},
                branches: [],
                grades: [],
                branchPrograms: [],
                patterns: [],
                branchClasses: [],
                semesters: semesters,
                graphData: {
                    donuts: [
                        {
                            title: {
                                show: false,
                                text: 0,
                                subtext: 'Jumlah Seluruh\nPeserta BTA',
                                top: '40%',
                                left: '27%',
                                textStyle: {
                                    fontSize: 32,
                                    fontFamily: 'Ubuntu-Bold',
                                    align: 'center'
                                },
                                subtextStyle: {
                                    fontSize: 16,
                                    fontFamily: 'Ubuntu-Regular',
                                    color: '#6c757d',
                                    align: 'center'
                                }
                            },
                            tooltip: {show: true},
                            legend: {
                                orient: 'vertical',
                                align: 'left',
                                left: 'right',
                                top: 'middle',
                                itemWidth: 15,
                                itemHeight: 15,
                                textStyle: {padding: [0, 0, 5, 10], fontFamily: 'Ubuntu-Regular', fontSize: 14},
                                data: []
                            },
                            series: [
                                {
                                    name: 'Cabang',
                                    type: 'pie',
                                    radius: ['50%', '65%'],
                                    center: ['20%', '50%'],
                                    itemStyle: {
                                        color: function (params) {
                                            return colors[params.dataIndex % colors.length];
                                        },
                                        barBorderRadius: [25, 25, 0, 0]
                                    },
                                    label: {
                                        show: true,
                                        position: 'top',
                                        fontSize: 14,
                                        fontFamily: 'Ubuntu-Bold',
                                        formatter: function (item) {
                                            return item.value;
                                        }
                                    },
                                    data: []
                                }
                            ]
                        },
                        {
                            title: {
                                show: false,
                                text: 0,
                                subtext: 'Jumlah\nPeserta',
                                top: '40%',
                                left: '27%',
                                textStyle: {
                                    fontSize: 32,
                                    fontFamily: 'Ubuntu-Bold',
                                    align: 'center'
                                },
                                subtextStyle: {
                                    fontSize: 16,
                                    fontFamily: 'Ubuntu-Regular',
                                    color: '#6c757d',
                                    align: 'center'
                                }
                            },
                            tooltip: {show: true},
                            legend: {
                                orient: 'vertical',
                                align: 'left',
                                left: 'right',
                                top: 'middle',
                                itemWidth: 15,
                                itemHeight: 15,
                                textStyle: {padding: [0, 0, 5, 10], fontFamily: 'Ubuntu-Regular', fontSize: 14},
                                data: []
                            },
                            series: [
                                {
                                    name: 'Kelas',
                                    type: 'pie',
                                    radius: ['50%', '65%'],
                                    center: ['20%', '50%'],
                                    itemStyle: {
                                        color: function (params) {
                                            return colors[params.dataIndex % colors.length];
                                        },
                                        barBorderRadius: [25, 25, 0, 0]
                                    },
                                    label: {
                                        show: true,
                                        position: 'top',
                                        fontSize: 14,
                                        fontFamily: 'Ubuntu-Bold',
                                        formatter: function (item) {
                                            return item.value;
                                        }
                                    },
                                    data: []
                                }
                            ]
                        },
                        {
                            title: {
                                show: false,
                                text: 0,
                                subtext: 'Jumlah Seluruh\nPeserta BTA',
                                top: '40%',
                                left: '27%',
                                textStyle: {
                                    fontSize: 32,
                                    fontFamily: 'Ubuntu-Bold',
                                    align: 'center'
                                },
                                subtextStyle: {
                                    fontSize: 16,
                                    fontFamily: 'Ubuntu-Regular',
                                    color: '#6c757d',
                                    align: 'center'
                                }
                            },
                            tooltip: {show: true},
                            legend: {
                                orient: 'vertical',
                                align: 'left',
                                left: 'right',
                                top: 'middle',
                                itemWidth: 15,
                                itemHeight: 15,
                                textStyle: {padding: [0, 0, 5, 10], fontFamily: 'Ubuntu-Regular', fontSize: 14},
                                data: []
                            },
                            series: [
                                {
                                    name: 'Sekolah',
                                    type: 'pie',
                                    radius: ['50%', '65%'],
                                    center: ['20%', '50%'],
                                    itemStyle: {
                                        color: function (params) {
                                            return colors[params.dataIndex % colors.length];
                                        },
                                        barBorderRadius: [25, 25, 0, 0]
                                    },
                                    label: {
                                        show: true,
                                        position: 'top',
                                        fontSize: 14,
                                        fontFamily: 'Ubuntu-Bold',
                                        formatter: function (item) {
                                            return item.value;
                                        }
                                    },
                                    data: []
                                }
                            ]
                        }
                    ],
                    bar: {
                        tooltip: {
                            show: true,
                            formatter: function (param) {
                                if (isNaN(param.name)) {
                                    return param.marker + param.name + ': ' + param.value;
                                }
                            }
                        },
                        grid: {
                            left: '4%',
                            right: '1%',
                            containLabel: true
                        },
                        xAxis: [
                            {
                                type: 'category',
                                data: [],
                                axisLine: {show: false},
                                axisTick: {show: false},
                                axisLabel: {
                                    rotate: 20,
                                    margin: 15,
                                    interval: 0,
                                    textStyle: {fontSize: 14, fontFamily: 'Ubuntu-Bold'}
                                }
                            },
                            {
                                type: 'category',
                                data: [],
                                axisLabel: {
                                    show: false
                                }
                            }
                        ],
                        yAxis: {min: 0, axisLabel: {fontSize: 14, fontFamily: 'Ubuntu-Medium'}, axisLine: {show: false}, axisTick: {show: false}},
                        series: [
                            {
                                name: 'Kelas',
                                zlevel: 2,
                                type: 'bar',
                                itemStyle: {
                                    color: function (params) {
                                        return colors[params.dataIndex % colors.length];
                                    },
                                    barBorderRadius: [25, 25, 0, 0]
                                },
                                label: {
                                    show: true,
                                    position: 'top',
                                    fontSize: 14,
                                    fontFamily: 'Ubuntu-Bold',
                                    offset: [0, -5]
                                },
                                barCategoryGap: '70%',
                                data: []
                            },
                            {
                                type: 'bar',
                                xAxisIndex: 1,
                                zlevel: 1,
                                itemStyle: {
                                    color: 'rgba(0,0,0,0.05)',
                                    barBorderRadius: [25, 25, 0, 0]
                                },
                                barCategoryGap: '70%',
                                animation: false,
                                data: []
                            }
                        ]
                    }
                }
            };
        },
        methods: {
            downloadScore() {
                let token = localStorage.getItem("vue-authenticate.vueauth_token");
                window.location = process.env.API_URL + '/student/bulk-report?' + qs.stringify(Object.assign({}, this.form.score, {token: token, termID: this.term.id}), {encode: false});
                this.modal.score = false;
                for (let attribute in this.form.score) {
                    this.form.score[attribute] = '';
                }
            },
            downloadStudent() {
                let token = localStorage.getItem("vue-authenticate.vueauth_token");
                window.location = process.env.API_URL + '/student/download?' + qs.stringify(Object.assign({}, this.form.student, {token: token, termID: this.term.id}), {encode: false});
                this.modal.student = false;
                for (let attribute in this.form.student) {
                    this.form.student[attribute] = '';
                }
            },
            downloadUTBK() {
                let token = localStorage.getItem("vue-authenticate.vueauth_token");
                window.location = process.env.API_URL + '/student/download-utbk-bulk?' + qs.stringify(Object.assign({}, this.form.utbk, {token: token, termID: this.term.id}), {encode: false});
                this.modal.utbk = false;
                for (let attribute in this.form.utbk) {
                    this.form.utbk[attribute] = '';
                }
            },
            fetchBranchGraph() {
                this.axios.get(process.env.API_URL + '/student/statistic/branch', {params: {termID: this.term.id}}).then(response => {
                    if (response.data.status) {
                        let data = response.data.data;
                        let graph = this.graphData.donuts[0];

                        let total = 0;
                        graph.legend.data = [];
                        graph.series[0].data = [];
                        for (let i = 0; i < data.length; i++) {
                            graph.legend.data.push({name: data[i].branch.name, icon: 'circle'});
                            graph.series[0].data.push({name: data[i].branch.name, value: data[i].total});
                            total += data[i].total;
                        }

                        graph.title.text = total;
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            fetchBranchGradeGraph() {
                this.axios.get(process.env.API_URL + '/student/statistic/branch-grade', {params: {termID: this.term.id}}).then(response => {
                    if (response.data.status) {
                        let data = response.data.data;
                        let graph = this.graphData.donuts[1];

                        let total = 0;
                        graph.legend.data = [];
                        graph.series[0].data = [];
                        for (let i = 0; i < data.length; i++) {
                            graph.legend.data.push({name: data[i].btaGrade.name, icon: 'circle'});
                            graph.series[0].data.push({name: data[i].btaGrade.name, value: data[i].total});
                            total += data[i].total;
                        }
                        graph.title.text = total;
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            fetchSchoolGraph() {
                let params = {
                    termID: this.term.id,
                    branchID: this.form.graph.donut.branchID,
                    gradeID: this.form.graph.donut.gradeID
                };

                this.axios.get(process.env.API_URL + '/student/statistic/school', { params }).then(response => {
                    if (response.data.status) {
                        let data = response.data.data;
                        let graph = this.graphData.donuts[2];

                        let total = 0;
                        graph.legend.data = [];
                        graph.series[0].data = [];
                        for (let i = 0; i < data.primary.length; i++) {
                            graph.legend.data.push({name: data.primary[i].school.name, icon: 'circle'});
                            graph.series[0].data.push({name: data.primary[i].school.name, value: data.primary[i].total});
                            total += data.primary[i].total;
                        }
                        graph.legend.data.push({name: 'Lainnya', icon: 'circle'});
                        graph.series[0].data.push({name: 'Lainnya', value: data.others.total});
                        total += data.others.total;

                        graph.title.text = total;
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            fetchGradeGraph() {
                this.axios.get(process.env.API_URL + '/student/statistic/grade', {params: {gradeIDs: this.form.graph.bar.gradeIDs, termID: this.term.id}}).then(response => {
                    if (response.data.status) {
                        let data = response.data.data;
                        let graph = this.graphData.bar;
                        graph.xAxis[0].data = [];
                        graph.xAxis[1].data = [];
                        graph.series[0].data = [];
                        graph.series[1].data = [];
                        for (let i = 0; i < data.length; i++) {
                            graph.xAxis[0].data.push(data[i].name);
                            graph.series[0].data.push(data[i].totalStudents);
                        }

                        let max = Math.max(...graph.series[0].data);
                        let ceiling = Math.ceil(max / 10) * 10;
                        for (let i = 0; i < data.length; i++) {
                            graph.xAxis[1].data.push(i);
                            graph.series[1].data.push(ceiling);
                        }
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            roleElligiblePrimary() {
                return this.profile.isAdmin || (this.profile.isEmployee && (this.profile.employee.isDirector || this.profile.employee.isManager));
            },
            roleElligibleSecondary() {
                return this.profile.isEmployee && (this.profile.employee.isBranchStaff || this.profile.employee.isBranchHead);
            },
            fetchData() {
                if (this.roleElligiblePrimary() || this.roleElligibleSecondary()) {
                    this.axios.all([
                        this.axios.get(process.env.API_URL + '/branch'),
                        this.axios.get(process.env.API_URL + '/grade')
                    ]).then(this.axios.spread(function (responseBranch, responseGrade) {
                        this.branches = responseBranch.data.data;
                        this.grades = responseGrade.data.data;

                        this.form.graph.bar.gradeIDs = this.grades.map(grade => grade.id);
                    }.bind(this)));

                    if (this.roleElligiblePrimary()) {
                        this.fetchBranchGraph();
                    } else {
                        if (this.profile.employee.isBranchStaff) {
                            this.guessBranch = this.profile.employee.branchStaff.branch;
                        } else if (this.profile.employee.isBranchHead) {
                            this.guessBranch = this.profile.employee.branchHead.branch;
                        }
                        this.form.graph.donut.branchID = this.guessBranch.id;
                        this.fetchBranchGradeGraph();
                    }
                    this.fetchSchoolGraph();
                }
            },
            resize() {
                let width = window.innerWidth || document.documentElement.clientWidth;
                for (let i = 0; i < this.graphData.donuts.length; i++) {
                    if (width < 767) {
                        this.graphData.donuts[i].title.show = true;
                        this.graphData.donuts[i].title.left = 'center';

                        this.graphData.donuts[i].legend.orient = 'horizontal';
                        this.graphData.donuts[i].legend.left = 'center';
                        this.graphData.donuts[i].legend.top = 'bottom';

                        this.graphData.donuts[i].series[0].center = ['50%', '50%'];
                    } else if (width < 992) {
                        this.graphData.donuts[i].title.show = false;

                        this.graphData.donuts[i].legend.orient = 'horizontal';
                        this.graphData.donuts[i].legend.left = 'center';
                        this.graphData.donuts[i].legend.top = 'bottom';

                        this.graphData.donuts[i].series[0].center = ['50%', '40%'];
                    } else {
                        this.graphData.donuts[i].title.show = false;
                        this.graphData.donuts[i].title.left = '27%';

                        this.graphData.donuts[i].legend.orient = 'vertical';
                        this.graphData.donuts[i].legend.left = 'right';
                        this.graphData.donuts[i].legend.top = 'middle';

                        this.graphData.donuts[i].series[0].center = ['20%', '50%'];
                    }
                }
            },
            fileUpload(event, name) {
                var input = event.currentTarget;
                let files = input.files;
                if (files && files[0]) {
                    this.form.upload[name] = files[0];
                }
            },
            upload() {
                var formData = new FormData();
                for (var attribute in this.form.upload) {
                    formData.set(attribute, this.form.upload[attribute]);
                }
                this.axios.post(process.env.API_URL + '/attendance/upload-attendance-report', formData).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.modal.upload = false;
                        this.fetchStudent();
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            patternLabel(pattern) {
                return pattern.periods.map(period => {
                    return this.$moment.weekdays(period.day) + ' ' + this.$moment(period.start, "HH:mm:ss").format('HH.mm') + ' - ' + this.$moment(period.end, "HH:mm:ss").format('HH.mm');
                }).join(" | ");
            }
        },
        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', this.resize);
                this.resize();

                this.fetchData();
            });

            document.title = 'Dashboard - ' + process.env.APP_NAME;
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.resize);
        }
    };
</script>

<style scoped>
    .graph-wrapper .title {
        top: 50%;
        width: 40%;
        transform: translateY(-50%);
        pointer-events: none;
    }
    .graph-wrapper .donut-chart {
        height: 320px;
    }

    .blink-active {
        animation: blink-active 2s infinite;
    }

    @keyframes blink-active {
        0%   { opacity: 1; }
        50%  { opacity: 0.4; }
        100% { opacity: 1; }
    }

    @media (max-width: 1199.98px) and (min-width: 992px){
        .graph-wrapper .title h1 {
            font-size: 1.5vw;
        }
        .graph-wrapper .title p{
            font-size: 0.8vw;
        }
    }
    @media (max-width: 991.98px) and (min-width: 768px) { 
        .graph-wrapper .title {
            top: 40%;
            width: 100%;
        }
        .graph-wrapper .title h1 {
            font-size: 2.7vw;
        }
        .graph-wrapper .title p{
            font-size: 1.2vw;
        }
    }
    @media (max-width: 767.98px) {
        .graph-wrapper .title {
            display: none;
        }
        .graph-wrapper .donut-chart {
            height: 500px;
        }
    }
    @media (max-width: 991.98px) {
        .form-divider::before{ display: none; }
    }

/* ==========================================================================
   POP UP
   ========================================================================== */

    .announcement-body {
        padding: 16px 32px;
    }

    .to-section {
        border: 1px solid #dee2e6;
        border-radius: 8px;
        overflow: hidden;
        margin-bottom: 15px;
    }

    .to-section-header {
        padding: 10px 15px;
        border-bottom: 1px solid #dee2e6;
    }

    .to-section-body {
        padding: 12px 15px;
    }

    .to-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 15px;
        padding: 7px 0;
    }

    .to-name {
        font-weight: 700;
        line-height: 1.3;
    }

    .to-date {
        white-space: nowrap;
        color: #555;
        font-size: 13px;
        text-align: right;
    }

    /* COMING NEXT */
    .to-row-next {
        background: #fff8e1;
        border-left: 4px solid #f9a825;
        padding: 10px 12px;
        border-radius: 6px;
        margin-bottom: 5px;
    }

    .to-badge-next {
        display: inline-block;
        background: #f9a825;
        color: white;
        font-size: 9px;
        padding: 3px 6px;
        border-radius: 4px;
        margin-left: 5px;
        vertical-align: middle;
        white-space: nowrap;
    }

    /* SEDANG BERLANGSUNG */
    .to-row-active {
        background: #e8f5e9;
        border-left: 4px solid #2e7d32;
        padding: 10px 12px;
        border-radius: 6px;
        margin-bottom: 5px;
    }

    .to-badge-active {
        display: inline-block;
        background: #2e7d32;
        color: white;
        font-size: 9px;
        font-weight: bold;
        padding: 3px 6px;
        border-radius: 4px;
        margin-left: 5px;
        vertical-align: middle;
        white-space: nowrap;
    }

    /* ================= MOBILE ================= */

    @media (max-width: 576px) {

        .announcement-body {
            padding: 15px 16px !important;
        }

        .announcement-title {
            font-size: 21px;
            line-height: 1.2;
        }

        .announcement-subtitle {
            font-size: 13px;
        }

        .to-section-body {
            padding: 8px 14px;
        }

        .to-row {
            gap: 8px;
            padding: 7px 0;
        }

        .to-name {
            font-size: 13px;
        }

        .to-date {
            font-size: 12px;
        }

        .to-row-next, .to-row-active {
            padding: 9px 10px;
        }

    }

    @media (max-width: 380px) {

        .to-row {
            align-items: flex-start;
            flex-direction: column;
            gap: 2px;
        }

        .to-date {
            text-align: left;
        }

    }
</style>


// WEBPACK FOOTER //
// src/components/Index.vue